import React, { useEffect, useRef, useState } from "react";
import lozad from "lozad";
import { reportError } from "@/helpers/errorHelper";
import Srcset from "../common/Srcset";

export default function VideoComp({ vidSrc, width, autoPlay = true,controls, thumbnail, section}) {
  const vidRef = useRef(null);
  const [url,setUrl]=useState(thumbnail?"icons/pause.svg":"icons/playsvg.svg");
  const handlePlay = () => {
    if (!thumbnail) {
      if (vidRef?.current?.paused) {
        vidRef?.current?.play();
      } else {
        vidRef?.current?.pause();
      }
    }
  }

  useEffect(() => {
    const observer = lozad(); // lazy loads elements with default selector as '.lozad'
    observer.observe();
  },[]);
  return (
    <>
      <div className={`video-wrapper`}>
        {vidRef?.current && <div className={`video-btn ${thumbnail?"thumbnail":''}`}  onClick={() => handlePlay()} >
          <Srcset
            src={url}
            loading="lazy"
            requirePath={true}
            svgFile={true}
            alt="video button"
            tabIndex={0}
          />
        </div>}
      <video
        ref={vidRef}
        onClick={() => handlePlay()}
        onPlay={() => {  setUrl("icons/playsvg.svg") }}
        onPause={()=>{setUrl("icons/pause.svg")}}
        src={vidSrc}
        preload="none"
          className={`lozad ${section!="plp"?`pdp-video`:""}`}
        loop
        autoPlay={autoPlay}
        muted
        playsInline
        controls={controls}
        style={{
          // maxWidth: "auto",
          // height: "80%",
          // width: "100%",
          objectFit: "contain",
        }}
        tabIndex={0}
      ></video>
      </div>
    </>
  );
}
